(() => {
  const descriptions = [
    [/^(um vöruna|lýsing)$/i, 'Yfirlit og helstu atriði'],
    [/^eiginleikar$/i, 'Helstu kostir vörunnar'],
    [/^(innihald|innihaldsefni)$/i, 'Hráefni og samsetning'],
    [/^næringargildi$/i, 'Greining og orkugildi'],
    [/^frekari upplýsingar$/i, 'Uppruni, ráðgjöf og afhending'],
    [/^ofnæmi og óþol$/i, 'Upplýsingar fyrir viðkvæm dýr'],
    [/^(aukabúnaður|aukahlutir)$/i, 'Vörur sem passa með'],
    [/^stærðir og mál$/i, 'Mátun og stærðarleiðbeiningar'],
    [/^leiðbeiningar um efni og umhirðu$/i, 'Efni, þrif og umhirða'],
    [/^tæknilegar upplýsingar$/i, 'Nánari vörueiginleikar'],
    [/^hvernig hjálpar þessi formúla\??$/i, 'Markmið og næringarstuðningur'],
    [/^vetline ábyrgð$/i, 'Ábyrgð og skilmálar'],
    [/^formúlan í hnotskurn$/i, 'Helstu atriði'],
    [/^af hverju heilfóður\??$/i, 'Hvað felst í heilfóðri'],
    [/^meira um vöruna$/i, 'Nánari upplýsingar']
  ];

  const cleanTextNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      node.nodeValue = node.nodeValue.replace(/[👉✅✔✓☑⏳🔸🌱🔥]\s*/gu, '');
    }
  };

  const splitLines = (paragraph) => paragraph.innerHTML
    .split(/<br\s*\/?>/i)
    .map((part) => part.trim())
    .filter(Boolean);

  const promoteDecisionList = (content) => {
    const paragraphs = Array.from(content.children).filter((element) => element.tagName === 'P');
    const candidates = paragraphs
      .map((paragraph) => ({ paragraph, parts: splitLines(paragraph) }))
      .filter(({ parts }) => parts.length >= 3 && parts.length <= 6);
    const checked = candidates.find(({ parts }) => parts.every((part) => /^[👉✅✔✓☑]\s*/u.test(part)));
    const plain = candidates.find(({ parts }) => parts.every((part) => {
      const probe = document.createElement('span');
      probe.innerHTML = part;
      const length = probe.textContent.trim().length;
      return length >= 12 && length <= 150;
    }));
    const candidate = checked || plain;
    if (!candidate) return null;

    const list = document.createElement('ul');
    list.className = 'dv-pdp-v14__summary-list';
    candidate.parts.forEach((part) => {
      const item = document.createElement('li');
      item.innerHTML = part.replace(/^[👉✅✔✓☑]\s*/u, '');
      list.append(item);
    });
    candidate.paragraph.replaceWith(list);
    return list;
  };

  const collapseLongFoodDetails = (content, summaryList) => {
    if (!summaryList || content.querySelector(':scope > .dv-pdp-v14__more')) return;
    const trailing = [];
    let sibling = summaryList.nextElementSibling;
    while (sibling) {
      trailing.push(sibling);
      sibling = sibling.nextElementSibling;
    }
    if (trailing.length < 3) return;

    const more = document.createElement('details');
    more.className = 'dv-pdp-v14__more';
    const summary = document.createElement('summary');
    summary.textContent = 'Lesa nánari lýsingu';
    const body = document.createElement('div');
    body.className = 'dv-pdp-v14__more-content';
    trailing.forEach((element) => body.append(element));
    more.append(summary, body);
    content.append(more);
  };

  const descriptorFor = (title) => {
    const match = descriptions.find(([pattern]) => pattern.test(title));
    return match ? match[1] : 'Nánari upplýsingar';
  };

  const enhanceContent = (details, title) => {
    const content = details.querySelector(':scope > .accordion__content');
    if (!content) return;
    const promoted = /^(um vöruna|lýsing|formúlan í hnotskurn)$/i.test(title)
      ? promoteDecisionList(content)
      : null;
    cleanTextNodes(content);

    const firstParagraph = Array.from(content.children)
      .find((element) => element.tagName === 'P' && element.textContent.trim());
    if (firstParagraph) firstParagraph.classList.add('dv-pdp-v14__lead');

    const lists = Array.from(content.querySelectorAll('ul, ol'));
    lists.forEach((list) => list.classList.add('dv-pdp-v14__detail-list'));
    if (promoted) promoted.classList.remove('dv-pdp-v14__detail-list');
    if (/^(um vöruna|lýsing|formúlan í hnotskurn)$/i.test(title)) {
      const summaryList = lists.find((list) => list.children.length >= 2 && list.children.length <= 4);
      if (summaryList && !promoted) {
        summaryList.classList.remove('dv-pdp-v14__detail-list');
        summaryList.classList.add('dv-pdp-v14__summary-list');
      }
    }
    const decisionList = promoted || content.querySelector(':scope > .dv-pdp-v14__summary-list');
    if (/^um vöruna$/i.test(title)) collapseLongFoodDetails(content, decisionList);
    if (/^lýsing$/i.test(title) && decisionList) {
      const fitNote = Array.from(content.children).find((element) =>
        element.tagName === 'P' && /^stærðarval:/i.test(element.textContent.trim())
      );
      if (fitNote) fitNote.classList.add('dv-pdp-v14__fit-note');
    }
  };

  const enhanceRoot = (root = document) => {
    const detailsList = Array.from(root.querySelectorAll('.product__accordion > details'))
      .filter((details) => details.querySelector(':scope > summary .tab_product_info88'));
    if (!detailsList.length) return;

    let overview = null;
    detailsList.forEach((details) => {
      if (details.dataset.dvPdpV14 === 'true') return;
      const heading = details.querySelector(':scope > summary .tab_product_info88');
      const summaryTitle = details.querySelector(':scope > summary .summary__title');
      const title = heading.textContent.trim();
      details.dataset.dvPdpV14 = 'true';
      details.classList.add('dv-pdp-v14');

      const subtitle = document.createElement('span');
      subtitle.className = 'dv-pdp-v14__subtitle';
      subtitle.textContent = descriptorFor(title);
      summaryTitle.append(subtitle);
      enhanceContent(details, title);

      if (/^(um vöruna|lýsing)$/i.test(title)) overview = details;
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        detailsList.forEach((other) => {
          if (other !== details && other.open) other.open = false;
        });
      });
    });

    if (!detailsList.some((details) => details.open)) {
      (overview || detailsList[0]).open = true;
    }
  };

  const init = () => enhanceRoot(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => enhanceRoot(event.target));
})();
